<app-loading *ngIf="contentReady"></app-loading>

<div class="vcash-policy-page" style="margin-bottom: 100px;">

  <!-- TOP HEADER -->
  <section class="vcash-top">
    <div class="vcash-appbar">
      <a class="appbar-btn" routerLink="/Profile">
        <img [src]="isAr ? '/assets/e-commerce/icons/60.webp' : '/assets/e-commerce/icons/61.webp'" alt="back" />
      </a>

      <h1 class="appbar-title">{{ '1' | transloco }}</h1>
      <div class="appbar-btn appbar-btn--ghost" routerLink="/notifications">
        <img src="/assets/e-commerce/icons/55.webp" alt="notifications" />
      </div>
    </div>
  </section>

  <!-- CONTENT -->
  <div class="vcash-content">

    <!-- SUMMARY CARD -->
    <section class="policy-summary-card">
      <div class="policy-summary-left">
        <span class="policy-overline">{{ "Information" | transloco }}</span>
        <h2>{{ '1' | transloco }}</h2>
        <p>{{ '2' | transloco }}</p>
      </div>

      <div class="policy-summary-icon">
        <img src="/assets/e-commerce/icons/62.webp" alt="info" />
      </div>
    </section>

    <!-- MAIN CONTENT CARD -->
    <section class="policy-main-card">
      <div class="policy-hero">
        <img src="/assets/e-commerce/icons/86.webp" alt="policy" />
      </div>

      <h2 class="policy-title">{{ '1' | transloco }}</h2>

      <div class="policy-body">
        <p>{{ '2' | transloco }}</p>

        <h3>{{ '3' | transloco }}</h3>
        <p>{{ '4' | transloco }}</p>
        <p>{{ '5' | transloco }}</p>
        <p>{{ '6' | transloco }}</p>

        <h3>{{ '7' | transloco }}</h3>
        <p>{{ '8' | transloco }}</p>
        <p>{{ '9' | transloco }}</p>

        <h3>{{ '10' | transloco }}</h3>
        <p>{{ '11' | transloco }}</p>

        <h3>{{ '12' | transloco }}</h3>
        <p>{{ '13' | transloco }}</p>
        <p>{{ '14' | transloco }}</p>
        <p>{{ '15' | transloco }}</p>
        <p>{{ '16' | transloco }}</p>
      </div>
    </section>

  </div>
</div>